import { Navigate, Route, Routes } from "react-router-dom";
import { MainPage } from "../MainPage/MainPage";
import { TermsPage } from "../TermsPage/TermsPage";
import { MarketPage } from "../MarketsPage/MarketPage";
import { TradingTerminal } from "../TradingPages/TradingTerminal/TradingTerminal";
import { Fundamentals } from "../TradingPages/Fundamentals/Fundamentals";
import { Analysis } from "../TradingPages/Analysis/Analysis";
import { TehnicalAnalysis } from "../TradingPages/TehnicalAnalysis/TechnicalAnalysis";
import { FAQ } from "../TradingPages/FAQ/FAQ";
import { AboutUsPage } from "../AboutUsPage/AboutUsPage";
import { ContactsPage } from "../ContactsPage/ContactsPage";
import { LogIn } from "../FormsPages/LogIn/LogIn";
import { Register } from "../FormsPages/Register/Register";
import { PasswordRecovery } from "../FormsPages/PasswordRecovery/PasswordRecovery";
import { ResetPassword } from "../FormsPages/ResetPassword/ResetPassword";
import { WithdrawlAccept } from "../WithdrawPages/WithdrawlAccept";
import { WithdrawlError } from "../WithdrawPages/WithdrawlError";
import { EmailErrorPage } from "../EmailErrorPage/EmailErrorPage";
import { ResetPasswordOK } from "../FormsPages/ResetPassword/ResetPasswordOK";
import { PasswordRecoveryMailComplited } from "../FormsPages/PasswordRecovery/PasswordRecoveryMailComplited";
import { EnglishRoutes } from "../../components/EnglishRoutes/EnglishRoutes";
import { LanguageHandler } from "../../components/LanguageHandler/LanguageHandler";
import { TwoFactorPage } from "../FormsPages/TwoFactorPage/TwoFactorPage";
import { RegisterMailPage } from "../FormsPages/Register/RegisterMailPage";

export const PageRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/en" replace />} />

      <Route element={<EnglishRoutes />}>
        <Route index element={<MainPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="market" element={<MarketPage />} />
        <Route path="trade" element={<TradingTerminal />} />
        <Route path="trade/fundamentals" element={<Fundamentals />} />
        <Route path="trade/analysis" element={<Analysis />} />
        <Route path="trade/tehnical-analysis" element={<TehnicalAnalysis />} />
        <Route path="trade/faq" element={<FAQ />} />
        <Route path="about-us" element={<AboutUsPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="auth/login" element={<LogIn />} />
        <Route path="auth/2fa" element={<TwoFactorPage />} />
        <Route path="auth/register" element={<Register />} />
        <Route path="auth/register/confirmed" element={<RegisterMailPage />} />
        <Route path="auth/forgot-password" element={<PasswordRecovery />} />
        <Route path="auth/forgot-password/email-successfully" element={<PasswordRecoveryMailComplited />} />
        <Route path="auth/reset-password" element={<ResetPassword />} />
        <Route path="auth/reset-password-ok" element={<ResetPasswordOK />} />
        <Route path="withdrawal/success" element={<WithdrawlAccept />} />
        <Route path="withdrawal/error" element={<WithdrawlError />} />
        <Route path="activation/error" element={<EmailErrorPage />} />
      </Route>

      <Route path="/:lang" element={<LanguageHandler />}>
        <Route index element={<MainPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="market" element={<MarketPage />} />
        <Route path="trade" element={<TradingTerminal />} />
        <Route path="trade/fundamentals" element={<Fundamentals />} />
        <Route path="trade/analysis" element={<Analysis />} />
        <Route path="trade/tehnical-analysis" element={<TehnicalAnalysis />} />
        <Route path="trade/faq" element={<FAQ />} />
        <Route path="about-us" element={<AboutUsPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="auth/login" element={<LogIn />} />
        <Route path="auth/2fa" element={<TwoFactorPage />} />
        <Route path="auth/register" element={<Register />} />
        <Route path="auth/register/confirmed" element={<RegisterMailPage />} />
        <Route path="auth/forgot-password" element={<PasswordRecovery />} />
        <Route path="auth/forgot-password/email-successfully" element={<PasswordRecoveryMailComplited />} />
        <Route path="auth/reset-password" element={<ResetPassword />} />
        <Route path="auth/reset-password-ok" element={<ResetPasswordOK />} />
        <Route path="withdrawal/success" element={<WithdrawlAccept />} />
        <Route path="withdrawal/error" element={<WithdrawlError />} />
        <Route path="activation/error" element={<EmailErrorPage />} />
      </Route>

      <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  );
};
